import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const VerifyEmail = () => {
  const { token } = useParams();
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/verify-email/${token}`);
        setMessage(response.data.message + " You can now log in.");
      } catch (error) {
        setError(error.response?.data?.message || "Verification failed");
      } finally {
        setIsLoading(false);
      }
    };
    verifyEmail();
  }, [token]);

  return (
    <div style={{ maxWidth: '400px', margin: '0 auto', fontFamily: 'sans-serif', marginTop: '20px', textAlign: 'center' }}>
      <h2>Email Verification</h2>
      {isLoading ? (
        <div>
          <p>Verifying your email...</p>
          <p style={{ 
            fontSize: '14px', 
            color: '#92400e',
            backgroundColor: '#fffbeb',
            padding: '12px',
            borderRadius: '8px',
            marginTop: '15px'
          }}>
            ⚠️ If you don't see the verification email, please check your spam folder.
          </p>
        </div>
      ) : error ? (
        <div>
          <p style={{ color: 'red' }}>{error}</p>
          <a href="/">Return to login</a>
        </div>
      ) : (
        <div>
          <p style={{ color: 'green' }}>{message}</p>
          {message.includes("successfully") && (
            <div style={{ marginTop: '20px' }}>
              <a href="/">Click here to login</a>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default VerifyEmail;
